import z from "zod";

export const refuseQuoteSchema = z.object({
  refusalReason: z.string().min(1),
});

export type InferredRefuseQuoteSchema = z.infer<typeof refuseQuoteSchema>;

export const defaultValuesRefuseQuote = {
  refusalReason: "",
} as const;
